import base from './base';

export const number = (value: any) => base(value);

export default number;
